function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}
export function centsToFloat(value) {
  if (isInt(value)) {
    return value / 100;
  }
  return value;
}
export function floatToCents(value) {
  if (value.includes('.')) {
    return parseInt(value.replace('.', ''), 10);
  }
  return value * 100;
}



// WEBPACK FOOTER //
// ./src/utils/numbers/centsFloat.js